import styled from '@emotion/styled';
import MuiCircularProgress from '@material-ui/core/CircularProgress';

const CircularProgress = styled(MuiCircularProgress, {
  shouldForwardProp: (prop) => prop !== 'color',
})`
  color: ${({ color }) => color};
`;

export default CircularProgress;
